// extracted by mini-css-extract-plugin
export default {"root":"LMMyPn6en4gaiQUuH4fw","placeHolderShimmer":"qCDevB_uAF6bYdsIlNw_"};